module.exports = {
	"AdUnit": {
		"ad_label": "Mainos"
	},
	"Article": {
		"by": "By",
		"related_news": "Aiheeseen liittyvät uutiset"
	},
	"ArticleShare": {
		"share_article": "Jaa artikkeli"
	},
	"PopularVideos": {
		"most_viewed": "Katsotuimmat"
	},
	"AuthorInfo": {
		"show_all": "Näytä kaikki"
	},
	"BlogIndex": {
		"heading1": "Kaikki",
		"heading2": "Blogit",
		"show_more": "Näytä lisää"
	},
	"CookieNotification": {
		"close": "Sulje"
	},
	"ContentMeta": {
		"all": "Kaikki",
		"goals": "Maalit",
		"game": "Ottelu",
		"summary": "Koosteet",
		"highlight": "Kohokohdat",
		"coverage": "Reportaasit",
		"studio": "Studiot",
		"program": "Ohjelmat",
		"top-list": "Top-lista",
		"interview": "Haastattelut",
		"live": "Live",
		"48hclip": " ",
		"vce-clip": " "
	},
	"EmbedPlayer": {
		"not_found": "404 Not found"
	},
	"ExpandableBox": {
		"show_more": "Näytä lisää"
	},
	"FeedContainerBig": {
		"extra": "Extra",
		"top_news": "Viimeisimmät uutiset",
		"blog": "Blogi",
		"podcast": "Podcast"
	},
	"FbCommentBox": {
		"show_comments": "Näytä kommentit"
	},
	"FollowFacebook": {
		"heading": "Seuraa meitä Facebookissa",
		"social_blurb": "Pidä itsesi ajantasalla"
	},
	"FollowMail": {
		"email_label": "Anna sähköpostiosoitteesi",
		"heading": "Tilaa uutiskirje",
		"see_examples": "Näytä esimerkkejä",
		"sign_up": "Tilaa",
		"social_blurb": "Pidä itsesi ajantasalla",
		"viaplay_option_description": "TV, Elokuva ja Urheilu uutudet",
		"viaplay_option_title": "Viaplayn uutiskirje",
		"viasport_option_description": "Urheilu-uutiset kerran viikossa",
		"viasport_option_title": "Viasatin urheilu-uutiskirje"
	},
	"FollowTwitter": {
		"heading": "Seuraa meitä Twitterissä",
		"social_blurb": "Pidä itsesi ajantasalla"
	},
	"LeagueIndex": {
		"heading": "Liigat"
	},
	"LeagueTables": {
		"result": "Tulokset",
		"table": "Taulukko"
	},
	"LiveScoreIndex": {
		"heading": "Livetulokset"
	},
	"LiveStreamListing": {
		"live": "Live!",
		"today": "Tänään",
		"tomorrow": "Huomenna"
	},
	"Login": {
		"forgot": "Unohditko käyttäjätunnuksesi tai salasanasi?",
		"heading": "Kirjaudu",
		"login_button": "Kirjaudu",
		"login_w_fb": "Kirjaudu Facebook tunnuksilla",
		"or": "tai",
		"password": "Salasana",
		"username": "Käyttäjätunnus",
		"email": "Email",
		"coming_soon": "Sisäänkirjautuminen lanseerataan myöhemmin tänä vuonna! Kirjautumalla pääset katsomaan vielä enemmän urheilusisältöjä, täysin ilmaiseksi. Jätä sähköpostiosoitteesi ja pysy ajantasalla.",
		"notify_me": "Lähetä",
		"registration_complete": "Email kirjattu!"
	},
	"Mail": {
		"email": "E-mail"
	},
	"MobileNav": {
		"social_blurb": "Pidä itsesi ajantasalla"
	},
	"Modal": {
		"close": "Sulje"
	},
	"Navbar": {
		"video": "Videot",
		"login": "Kirjaudu",
		"menu": "Menu",
		"popular_teams": "Suosituimmat joukkueet",
		"popular_leagues": "Suosituimmat liigat"
	},
	"NoMatch": {
		"heading": "404",
		"body": "We couldn't find the page you were looking for. You may have mistyped the address or the page may have been moved.",
		"viasport_startpage": "Return to the start page"
	},
	"Notifications": {
		"close": "Sulje",
		"country_warning": "We see that you are visiting our site from a country other than Finland. For copyright reasons, some videos may not be available to you."
	},
	"PageHeading": {
		"news": "Uutiset"
	},
	"PodcastIndex": {
		"heading1": "Kaikki",
		"heading2": "Podcastit",
		"show_more": "Näytä lisää"
	},
	"Poll": {
		"button": "Äänestys",
		"error": "Error while saving vote."
	},
	"SearchForm": {
		"cancel": "Peruuta"
	},
	"SearchPage": {
		"results_for": "Hakutulosta"
	},
	"Signup": {
		"heading": "Liity",
		"login_button": "Kirjaudu",
		"or": "tai",
		"password": "Salasana",
		"signup_w_fb": "Kirjaudu Facebook-tunnuksilla",
		"username": "Käyttäjänimi"
	},
	"SocialArea": {
		"email": "E-mail",
		"social_blurb": "Pidä itsesi ajantasalla"
	},
	"StoryNav": {
		"next": "Seuraava artikkeli"
	},
	"TablesIndex": {
		"heading": "Taulukot"
	},
	"TeamIndex": {
		"heading": "Joukkueet",
		"popular_teams": "Joukkueet"
	},
	"TotalShares": {
		"total_shares": "Jaettu"
	},
	"TvGuide": {
		"heading": "Ohjelmaopas"
	},
	"TwitterFollowWidget": {
		"follow": "Seuraa"
	},
	"UnsupportedBrowser": {
		"heading": "Hups, selaimesi on vanhentunut eikä tue viasport.fi -sivustoa.",
		"body": "Huomasimme että käytät selainta jota emme tue. Mikäli haluat jatkaa katsomista tulee sinun ladata muu selain.",
		"meta": "Tässä yleisimmät selaimet joita sivustomme tukee.",
		"close": "Sulje"
	},
	"UserArea": {
		"login": "Kirjaudu",
		"signup": "Liity",
		"login_blurb": "Lisää parasta urheilua"
	},
	"ViaplayLiveFeed": {
		"text": "Katso urheilua livenä, missä ikinä oletkin. Tilaa Viaplay!",
		"button": "Kokeile",
		"highlight_streams": "Päälähetykset",
		"all_streams": "Kaikki",
		"link": "http://viaplay.fi/urheilu",
		"linkText": "Muita lähetysten viaplay.fi"
	},
	"VideoIndex": {
		"show_clip": "Katso video",
		"show_clips": "Näytä kaikki",
		"show_clips_2": "videota",
		"summary": "Kaikki koosteet",
		"clip": "klippi",
		"clips": "klipit",
		"heading": "Videot",
		"no_events_for_date": "Ei videoita tälle päivämäärälle",
		"no_events": "Ei tapahtumia",
		"today": "tänään",
		"yesterday": "eilen"
	},
	"VideoPlayer": {
		"watch_again": "Toista video uudelleen",
		"related_videos": "Suosittelemme",
		"unsupported_browser": "Hei! Näemme että käytät selainta emme tue. Jatka katselua suosittelemme",
		"chrome_link_text": "ladata Google Chrome-selain",
		"video_expired": "Pahoittelemme, mutta tämä video julkaista aika on rajoitettu 48 tuntia ja ei ole enää saatavilla"
	},
	"WidgetIndex": {
		"player_info": "Pelajaa info",
		"squad_stats": "Joukkue info"
	},
	"InfiniteScroll": {
		"no_more_articles": "Olet saavuttanut loppuun virtauksen."
	},
	"Premium": {
		"heading": "Premium"
	},
	"Thumbnail": {
		"playing": "Nyt käynnissä"
	},
	"Feedback": {
		"widgetTitle": "Kerro mielipiteesi",
		"formTitle": "Arvosana",
		"message": "Mitä toivot meidän parantavan?",
		"name": "Nimi",
		"email": "Sähköposti",
		"notify": "Are you interesting in receiving information about user-testing in our HQ in Stockholm, Sweden?",
		"close": "Sulje",
		"send": "Lähetä"
	}
};


//////////////////
// WEBPACK FOOTER
// ./l10n/fi.json
// module id = 693
// module chunks = 6